import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShelves = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M140.001-58.078v-843.459H200v81.923h560v-81.923h59.999v843.459H760v-81.923H200v81.923h-59.999ZM200-520h92.309v-155.384h215.382V-520H760v-239.615H200V-520Zm0 320h252.309v-155.384h215.382V-200H760v-260.001H200V-200Zm152.307-320h95.386v-95.386h-95.386V-520Zm160 320h95.386v-95.386h-95.386V-200Zm-160-320h95.386-95.386Zm160 320h95.386-95.386Z" })
});
export default SvgShelves;
